import axios from "axios"
import { SortDescriptor } from "@progress/kendo-data-query";
import { ErrorFilter } from "../models/error-center-model";

export const ERRORCENTER_URL = `${process.env.REACT_APP_API_URL}/ErrorCenter`;
export const DRAFTINVOICE_URL = `${process.env.REACT_APP_API_URL}/DraftInvoice`;

const SORT_FIELD_MAP: { [key: string]: string } = {
    id: 'Id',
    invoiceNumber: 'InvoiceNumber',
    invoicedName: 'InvoicedName',
    invoicedType: 'InvoicedType',
    xeroSendErrorMessage: 'XeroSendErrorMessage',
    xeroSendAttemptCount: 'XeroSendAttemptCount',
    xeroLastAttemptAtUtc: 'XeroLastAttemptAtUtc',
    xeroSendErrorType: 'XeroSendErrorType'
}

const normalizeSort = (pageSort: SortDescriptor) => {
    if (!pageSort || !pageSort.field || !pageSort.dir) return '';

    const field = SORT_FIELD_MAP[pageSort.field] || pageSort.field;
    return `${field} ${pageSort.dir}`;
}

export const getErrorCenter = async (skip: number, take: number, pageSort: SortDescriptor, filter: ErrorFilter) => {
    return await axios.post(`${ERRORCENTER_URL}/table`, {
        take,
        skip,
        sort: normalizeSort(pageSort),
        filter: { ...filter },
    });
}

export const resendToXero = async (id: number) => {
    var ids: number[] = [];
    ids.push(id);

    return await axios.post(`${DRAFTINVOICE_URL}/send-to-xero`, { ids });
}